// Web version of custom cipher storage using localStorage

const CUSTOM_CIPHERS_KEY = 'gematria_custom_ciphers';

// Get all custom ciphers
export const getCustomCiphers = async () => {
  try {
    const customCiphersJson = localStorage.getItem(CUSTOM_CIPHERS_KEY);
    if (customCiphersJson) {
      return JSON.parse(customCiphersJson);
    }
    return {};
  } catch (error) {
    console.error('Error loading custom ciphers:', error);
    return {};
  }
};

// Save a custom cipher
export const saveCustomCipher = async (cipherId, cipherData) => {
  try {
    const customCiphers = await getCustomCiphers();
    customCiphers[cipherId] = {
      ...cipherData,
      isCustom: true,
      createdAt: new Date().toISOString()
    };
    localStorage.setItem(CUSTOM_CIPHERS_KEY, JSON.stringify(customCiphers));
    return true;
  } catch (error) {
    console.error('Error saving custom cipher:', error);
    return false;
  }
};

// Delete a custom cipher
export const deleteCustomCipher = async (cipherId) => {
  try {
    const customCiphers = await getCustomCiphers();
    delete customCiphers[cipherId];
    localStorage.setItem(CUSTOM_CIPHERS_KEY, JSON.stringify(customCiphers));
    return true;
  } catch (error) {
    console.error('Error deleting custom cipher:', error);
    return false;
  }
};

// Generate unique cipher ID
export const generateCipherId = (name) => {
  const timestamp = Date.now();
  const sanitized = name.toLowerCase().replace(/[^a-z0-9]/g, '_');
  return `custom_${sanitized}_${timestamp}`;
};
